import React from 'react'
import { Typography } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Hidden from '@material-ui/core/Hidden'
import FooterLink from './footer-link/footer-link'
import './footer-links.css'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  linkContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    marginTop: 15,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(0.75),
      marginTop: theme.spacing(2),
    },
  },
  textSeparatorContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      gap: theme.spacing(0.75),
    },
  },
  footerLinksSeparator: {
    color: theme.palette.footer.main,
  },
}))

const FooterLinks = () => {
  const classes = useStyles()
  const brand = useSelector((state) => state.reducer.brand)
  let position = 0
  return (
    <div className={classes.linkContainer}>
      {Object.keys(brand?.linksData.footerLinks)?.map((link) => {
        const url = brand?.linksData.footerLinks[link]

        if (!!url) {
          position += 1
          return (
            <Typography key={link} variant='body2' className={classes.textSeparatorContainer}>
              {position > 1 && (
                <Hidden mdDown>
                  <span className={classes.footerLinksSeparator}>|</span>
                </Hidden>
              )}
              <FooterLink text={`footer.link.${link}`} name={link} link={url} />
            </Typography>
          )
        }
        return undefined
      })}
    </div>
  )
}

export default FooterLinks
